// extracted by mini-css-extract-plugin
export var footer = "_n1-5";
export var fulfillmentInput = "_n1-0";
export var shipDateInput = "_n1-1";
export var shipmentModal = "_n1-2";
export var shipmentModalContent = "_n1-3";
export var tableContainer = "_n1-4";